"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="View.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxView object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxView = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxView = /** @class */ (function (_super) {
    __extends(HxView, _super);
    function HxView(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxView, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxView.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '94':
                        this.accountId = new HxObjectID_1.default(v);
                        break;
                    case '1221':
                        this.canCreateContents = v;
                        break;
                    case '1222':
                        this.canCreateHierarchy = v;
                        break;
                    case '1223':
                        this.canDelete = v;
                        break;
                    case '1224':
                        this.canModify = v;
                        break;
                    case '1225':
                        this.canViewPrivateItems = v;
                        break;
                    case '1195':
                        this.childrenId = new HxObjectID_1.default(v);
                        break;
                    case '13C9':
                        this.classicGroupedConversationsNeedsRebuilt = v;
                        break;
                    case '13CD':
                        this.classicMessageConversationsNeedsRebuilt = v;
                        break;
                    case '84':
                        this.conversationsId = new HxObjectID_1.default(v);
                        break;
                    case '324':
                        this.conversationsFlaggedId = new HxObjectID_1.default(v);
                        break;
                    case '767':
                        this.conversationsMentionedId = new HxObjectID_1.default(v);
                        break;
                    case '645':
                        this.conversationsNeedsRebuilt = v;
                        break;
                    case '1513':
                        this.conversationsPinnedId = new HxObjectID_1.default(v);
                        break;
                    case '323':
                        this.conversationsUnreadId = new HxObjectID_1.default(v);
                        break;
                    case 'B37':
                        this.conversationsWithAttachmentsId = new HxObjectID_1.default(v);
                        break;
                    case '65C':
                        this.conversationViewMode = v;
                        break;
                    case '8B':
                        this.createdTime = new Date(v);
                        break;
                    case '1637':
                        this.deleteItemsPermission = v;
                        break;
                    case '96':
                        this.deviceId = v;
                        break;
                    case '1638':
                        this.editItemsPermission = v;
                        break;
                    case '89':
                        this.fullPath = v;
                        break;
                    case '1196':
                        this.hasChildren = v;
                        break;
                    case 'B16':
                        this.hasMoreMessageHeaders = v;
                        break;
                    case '8A':
                        this.indent = v;
                        break;
                    case 'D7B':
                        this.isDefaultSyncEnabled = v;
                        break;
                    case 'B1B':
                        this.isFavorite = v;
                        break;
                    case '91':
                        this.isLocal = v;
                        break;
                    case '3DF':
                        this.isSyncEnabled = v;
                        break;
                    case '3FC':
                        this.isUnifiedView = v;
                        break;
                    case '8C':
                        this.lastAccessedTime = new Date(v);
                        break;
                    case '15D6':
                        this.lastSeenMessageHeaderSortTime = new Date(v);
                        break;
                    case '8D':
                        this.lastSyncedTime = new Date(v);
                        break;
                    case '83':
                        this.name = v;
                        break;
                    case '88':
                        this.parentViewId = new HxObjectID_1.default(v);
                        break;
                    case '1639':
                        this.readItemsPermission = v;
                        break;
                    case 'F72':
                        this.readOnlyIsSearchEnhanced = v;
                        break;
                    case '7D7':
                        this.readOnlySearchStatus = v;
                        break;
                    case '99':
                        this.refreshViewStatus = v;
                        break;
                    case '95':
                        this.serverId = v;
                        break;
                    case 'F25':
                        this.sortDirection = v;
                        break;
                    case 'F26':
                        this.sortProperty = v;
                        break;
                    case 'E7C':
                        this.subfoldersTreeExpanded = v;
                        break;
                    case '158A':
                        this.supportsPinMailItemActions = v;
                        break;
                    case '8F':
                        this.syncStatus = v;
                        break;
                    case '360':
                        this.tileId = v;
                        break;
                    case '91E':
                        this.toastGroupId = v;
                        break;
                    case '82':
                        this.type = v;
                        break;
                    case '36A':
                        this.uiFullPath = v;
                        break;
                    case '86':
                        this.unreadCount = v;
                        break;
                    case 'BB2':
                        this.watermarkPushNotificationEnabled = v;
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxView.prototype.getAccount = function (sessionId) {
        return this.activeSet.getObject(this.accountId, sessionId).then(function (result) { return result; });
    };
    HxView.prototype.getChildren = function (sessionId) {
        return this.activeSet.getCollection(this.childrenId, sessionId);
    };
    HxView.prototype.getConversationsVirtualized = function (sessionId) {
        return this.activeSet.getVirtualizedCollection(this.conversationsId, sessionId);
    };
    HxView.prototype.getConversations = function (sessionId) {
        return this.activeSet.getCollection(this.conversationsId, sessionId);
    };
    HxView.prototype.getConversationsFlaggedVirtualized = function (sessionId) {
        return this.activeSet.getVirtualizedCollection(this.conversationsFlaggedId, sessionId);
    };
    HxView.prototype.getConversationsFlagged = function (sessionId) {
        return this.activeSet.getCollection(this.conversationsFlaggedId, sessionId);
    };
    HxView.prototype.getConversationsMentionedVirtualized = function (sessionId) {
        return this.activeSet.getVirtualizedCollection(this.conversationsMentionedId, sessionId);
    };
    HxView.prototype.getConversationsMentioned = function (sessionId) {
        return this.activeSet.getCollection(this.conversationsMentionedId, sessionId);
    };
    HxView.prototype.getConversationsPinnedVirtualized = function (sessionId) {
        return this.activeSet.getVirtualizedCollection(this.conversationsPinnedId, sessionId);
    };
    HxView.prototype.getConversationsPinned = function (sessionId) {
        return this.activeSet.getCollection(this.conversationsPinnedId, sessionId);
    };
    HxView.prototype.getConversationsUnreadVirtualized = function (sessionId) {
        return this.activeSet.getVirtualizedCollection(this.conversationsUnreadId, sessionId);
    };
    HxView.prototype.getConversationsUnread = function (sessionId) {
        return this.activeSet.getCollection(this.conversationsUnreadId, sessionId);
    };
    HxView.prototype.getConversationsWithAttachmentsVirtualized = function (sessionId) {
        return this.activeSet.getVirtualizedCollection(this.conversationsWithAttachmentsId, sessionId);
    };
    HxView.prototype.getConversationsWithAttachments = function (sessionId) {
        return this.activeSet.getCollection(this.conversationsWithAttachmentsId, sessionId);
    };
    HxView.prototype.getParentView = function (sessionId) {
        return this.activeSet.getObject(this.parentViewId, sessionId).then(function (result) { return result; });
    };
    return HxView;
}(HxObject_1.default));
exports.HxView = HxView;
exports.default = HxView;
